import * as Yup from "yup";

export const BaseObserverTableSchema = Yup.object().shape({});

export const CreateObserverTableSchema = BaseObserverTableSchema.shape({
    table_name: Yup.string().required("Пожалуйста, укажите название таблицы"),
});

export const UpdateObserverTableSchema = BaseObserverTableSchema.shape({});
